import {useState, useEffect} from "react";
import {Row, Container, Card} from "react-bootstrap";
import {selectProyect} from '../actions/proyects.actions';
import {useSelector, useDispatch} from "react-redux";
import Moment from "react-moment";
// import moment from 'moment';
import Operativos from "../components/Operativos";
// import { KeyboardDatePicker } from "@material-ui/pickers";
import {SelectedDateFn, selectedScaleFn} from '../actions/auth.action';
import { FormControl, Grid, InputLabel, MenuItem, Select } from "@material-ui/core";
import { saveUserPreferences } from "../services/apiPreferences";

// import Proyeccion from "../components/Proyeccion";
// import JSONpretty from 'react-json-pretty';

const IdProyect = ({match, codProyect, codType, codClassification}) => {
	// console.log(location)
	const dispatch = useDispatch();
	const proyects = useSelector((state) => state.proyects);
	const auth = useSelector(state => state.auth);
	const [loading, setLoading] = useState(true);
	const [data, setData] = useState({});
	const [titleCard, setTitleCard] = useState('');
	// const [openCalendar, setOpenCalendar] = useState(false);
	let codProject = match?.params.codProject || codProyect;
	// let codClassification = match?.params.codClassification || codClassification;

	const handleDateChange = (date) =>{
		// dispatch(SelectedDateFn(''))
		saveUserPreferences({
			scaleSelected: `${auth.scaleSelected}`,
			dateSelected: date,
		}).then(({data}) => {
			console.log('---- save preferences date response', data)
		}).catch(e => console.error(e))
		.finally(() => {
			dispatch(SelectedDateFn(date))
		})
	}

	const handleScaleChange = (scale) => {
		dispatch(SelectedDateFn(''))
		dispatch(selectedScaleFn(`${scale || 0}`))
		saveUserPreferences({
			scaleSelected: `${scale}`,
			dateSelected: auth.dateSelected,
		}).then(({data}) => {
			console.log('---- save preferences scale response', data)
		}).catch(e => console.error(e))
	}
	
	useEffect(() => {
		if (auth.loadingPreferences || !auth.dateSelected) {
			return;
		}
		dispatch(selectProyect(codProject, codType, auth.dateSelected, auth.scaleSelected));
		// eslint-disable-next-line
	}, [codProject, auth.dateSelected, auth.loadingPreferences]);

	useEffect(() => {
		setData(proyects.DataCards[0]);
		setLoading(false);
		// eslint-disable-next-line
	}, [proyects.DataCards[0]])

	const finalTitleCard = loading 
							? 'cargando...'
							: !data
								? 'Sin información'
								: `RO - ${data?.Proyecto || ''} ${titleCard || ''}`
	return (
		<Container style={{width: '100%', maxWidth: '100%'}}>
			{<Row>
				<Card className="w-100 mb-1 mt-2">
					<Card.Header className="bg-primary p-0 d-flex align-items-center justify-content-around mb-0">
						<Grid container direction="row" justifyContent="space-between" alignItems="center">
							<Grid item xs={8}>
								<h5 className="mb-0 ml-5" style={{maxWidth: '50%'}} >
									{finalTitleCard}
								</h5>
							</Grid>

							<Grid item xs={2}>
								<h5 className="mb-0 ml-1" style={{width: 120}}>
									<FormControl >
										<InputLabel shrink id="scales-label" style={{color: 'white'}}>
											Escala
										</InputLabel>
										<Select
											labelId="scales-label"
											id="scales"
											// value={scale}
											value={auth.scaleSelected}
											onChange={(event) => {
												handleScaleChange(event.target.value);
											}}
											displayEmpty
											fullWidth
											// className={classes.selectEmpty}
										>
											<MenuItem value="">
												<em>Por defecto</em>
											</MenuItem>
											<MenuItem value={0}>Mensual</MenuItem>
											<MenuItem value={1}>Semanal</MenuItem>
											<MenuItem value={2}>Anual</MenuItem>
										</Select>
									</FormControl>
									
								</h5>
							</Grid>
							<Grid item xs={2}>

								<div className="mb-0 ml-1 d-flex  align-items-center">

									<FormControl >
										<InputLabel shrink id="dates-label" style={{color: 'white'}}>
											Hasta
										</InputLabel>
										<Select
											labelId="dates-label"
											id="dates"
											value={auth.dateSelected}
											onChange={event => handleDateChange(event.target.value)}
											displayEmpty
											fullWidth
											// className={classes.selectEmpty}
										>
											{/* <MenuItem value="">
												<em></em>
											</MenuItem> */}
											{proyects.dates.map((d, i) => (
												<MenuItem key={`${i}`} value={d.CodPeriodo}>{d.DesPeriodo}</MenuItem>
											))}
										</Select>
									</FormControl>
								</div>
							</Grid>
						</Grid>
					</Card.Header>
					<Card.Body className="p-1">
					
						<div className="d-flex justify-content-around">
						
							<Card.Text className="mb-1">
								Monto({data?.Moneda || ''}){" "}
								{Intl.NumberFormat("en").format(data?.MontoContrato || '')}
							</Card.Text>

							<Card.Text className="mb-1">
								<Moment format="DD/MM/YYYY">
									{data?.FechaInicioReal || ''}
								</Moment>{" "}
								-{" "}
								<Moment format="DD/MM/YYYY">
									{data?.FechaFinReal || ''}
								</Moment>
							</Card.Text>
							<Card.Text className="text-primary mb-2">
								({data?.ReporteA || ''})
							</Card.Text>

							<Card.Text className="m-0 ml-3">
							{
								data?.FechaProcesoRO || '' ?( 
								<>
									Procesado:
									<Moment className="ml-2" format="DD/MM/YYYY hh:mm:ss a">
										{data?.FechaProcesoRO || ''}
									</Moment>
								</>): 'Sin procesar'
							}
								
								</Card.Text>
						</div>

						<div className="d-flex justify-content-around">
							<div>
								<div className="d-flex align-items-center mb-1">
									<div
										className="bg-blue card-h5 mr-2 d-flex"
										style={{
											width: 10,
											height: 10,
											borderRadius: "50%",
										}}
									></div>
									Programado ({data?.Moneda || ''})
								</div>
								<p className="mb-1 text-right">
									{" "}
									{Intl.NumberFormat("en").format(data?.Programado || '')}
								</p>
								<p className="mb-1 text-right">
									{" "}
									{data?.PorcentajeProgramado || ''}%
								</p>
							</div>

							<div>
								<div className="d-flex align-items-center mb-1">
									<div
										className="bg-yellow card-h5 mr-2 "
										style={{
											width: 10,
											height: 10,
											borderRadius: "50%",
										}}
									></div>
									Valorizado
								</div>
								<p className={`mb-1 ${data?.PorcentajeFA || '' < 0 ? 'text-danger' : 'text-success'} text-right`}>
									{" "}
									{Intl.NumberFormat("en").format(data?.Valorizado || '')}
								</p>
								<p className={`mb-1 ${data?.PorcentajeFA || '' < 0 ? 'text-danger' : 'text-success'} text-right`}>
									{" "}
									{data?.PorcentajeValorizado || ''}%
								</p>
							</div>

							<div>
								<div className="d-flex align-items-center mb-1">
									<div
										className="bg-aqua card-h5 mr-2"
										style={{
											width: 10,
											height: 10,
											borderRadius: "50%",
										}}
									></div>
									Real
								</div>
								<p className={`mb-1 ${data?.PorcentajeFC || '' < 0 ? 'text-danger' : 'text-success'} text-right`}>
									{" "}
									{Intl.NumberFormat("en").format(data?.Real || '')}
								</p>
								<p className={`mb-1 ${data?.PorcentajeFC || '' < 0 ? 'text-danger' : 'text-success'} text-right`}>
									{" "}
									{data?.PorcentajeReal || ''}%
								</p>
							</div>

							<div>
								<h5 className="card-h5">Fa</h5>
								<p className={`mb-1 ${data?.PorcentajeFA || '' < 0 ? 'text-danger' : 'text-success'} text-right`}>
									{" "}
									{data?.FA || ''}
								</p>
								<p className={`mb-1 ${data?.PorcentajeFA || '' < 0 ? 'text-danger' : 'text-success'} text-right`}>
									{data?.PorcentajeFA || ''}%
								</p>
							</div>

							<div>
								<h5>Fc</h5>
								<p className={`mb-1 ${data?.PorcentajeFC || '' < 0 ? 'text-danger' : 'text-success'} text-right`}>
									{" "}
									{data?.FC || ''}
								</p>
								<p className={`mb-1 ${data?.PorcentajeFC || '' < 0 ? 'text-danger' : 'text-success'} text-right`}>
									{data?.PorcentajeFC || ''}%
								</p>
							</div>
						</div>

						<div className="w-100">
							<div className="progress-group  d-flex justify-content-between">
								<div style={{width: '90%'}}>
									<div className="progress progress-sm m-2">
										<div
											className="progress-bar bg-blue"
											style={{
												width: `${data?.PorcentajeProgramado || ''}%`,
											}}
										></div>
									</div>
								</div>

								<div style={{width: '10%'}}>
									<b  className="porcentaje-barra">{data?.PorcentajeProgramado || ''}%</b>
								</div>
							</div>

							<div className="progress-group d-flex justify-content-between">
								<div style={{width: '90%'}}>
									<div className="progress progress-sm m-2">
										<div
											className="progress-bar bg-yellow"
											style={{
												width: `${data?.PorcentajeValorizado || ''}%`,
											}}
										></div>
									</div>
								</div>

								<div style={{width: '10%'}}>
									<b className="porcentaje-barra"> {data?.PorcentajeValorizado || ''}%</b>
								</div>
							</div>

							<div className="progress-group d-flex justify-content-between">
								<div style={{width: '90%'}}>
									<div className="progress progress-sm m-2">
										<div
											className="progress-bar bg-aqua"
											style={{
												width: `${data?.PorcentajeReal || ''}%`,
											}}
										></div>
									</div>
								</div>

								<div style={{width: '10%'}}>
									<b  className="porcentaje-barra"> {data?.PorcentajeReal || ''}%</b>
								</div>
							</div>
						</div>
					</Card.Body>
				</Card>
			</Row>}

			{/* <JSONpretty data={proyects.treePartyControl} /> */}

			<Operativos 
				CodProyect={codProject}
				setTitleCard={setTitleCard}
				codType={codType}
				codClassification={codClassification}
			 />
			{/* <Proyeccion /> */}
			{/* <hr />

			<h3 className="text-center mb-3">Liquidez</h3> */}
			
		</Container>
	);
};
export default IdProyect;
